module.exports = __webpack_public_path__ + "static/media/icon_156.cf540dc7.svg";